import React from "react"
import {
    validateFields,
    stringifyInvalidEmails,
    parseFieldsToTextArea,
    parseTextAreaToFields,
    makeInviteField,
    updateBaseMapField,
    checkIfEmailIsValid,
} from "../util/onboarding_utils"
import { appStrings } from "../common/strings/app_strings"
import InviteMemberRow from "../components/onboarding/invite_member_row"
import ToggleAddAnother from "./onboarding/toggle_add_another"
import { guid } from "../util/random_utils"
import { appConsts } from "../common/constants/app_consts"
const { regExEmailValidation } = appConsts

const {
    followingAreInvalid,
    inviteYourTeamInviteOneByOne,
    textAreaPlaceholder,
} = appStrings.onboarding

export class InviteTeamMembers extends React.Component {
    constructor() {
        super()

        this.textInput = null
        this.setTextInputRef = element => (this.textInput = element)
        this.focusTextInput = () => {
            if (this.textInput) this.textInput.focus()
        }
    }

    delayedFocus = () => {
        setTimeout(() => {
            this.focusTextInput()
        }, 200)
    }

    addInviteMemberRow = () => {
        const id = guid()
        const fields = {
            ...this.props.fields,
            [id]: makeInviteField("", false, true, id),
        }
        this.props.updateState("fields", fields)
        this.delayedFocus()
    }

    removeInviteMemberRow = id => {
        const fields = { ...this.props.fields }
        delete fields[id]

        this.props.updateState("fields", fields)
        this.delayedFocus()
    }

    toggleIsTextArea = () => {
        const { fields, isTextArea, textAreaContent } = this.props
        if (!isTextArea) {
            const newTextAreaContent = parseFieldsToTextArea(fields)
            this.props.updateState("textAreaContent", newTextAreaContent)
        } else {
            const newFields = parseTextAreaToFields(textAreaContent)
            this.props.updateState("fields", newFields)
        }
        this.props.updateState("isTextArea", !isTextArea)
        this.delayedFocus()
    }

    handleIsValidFieldChange = (fields, value, id, type) => {
        const fieldsHasBlurred = fields[id].hasBlurred

        if (type === "email" && fieldsHasBlurred) {
            const emailIsValid = checkIfEmailIsValid(
                value,
                regExEmailValidation,
            )
            return updateBaseMapField(fields, emailIsValid, id, "isValid")
        }
    }

    handleBlur = (value, id, type) => {
        const { fields } = this.props

        if (fields[id].email) {
            const updatedHasBlurred = updateBaseMapField(
                fields,
                true,
                id,
                "hasBlurred",
            )
            const updateIsValidField = this.handleIsValidFieldChange(
                updatedHasBlurred,
                value,
                id,
                type,
            )

            this.props.updateState("fields", updateIsValidField)
        }
    }

    handleTextFieldChange = (value, id, type) => {
        const { fields } = this.props

        const updateIsValidField = this.handleIsValidFieldChange(
            fields,
            value,
            id,
            type,
        )
        const fieldHasBeenUpdated = updateIsValidField
            ? updateIsValidField
            : fields
        const updatedFields = updateBaseMapField(
            fieldHasBeenUpdated,
            value,
            id,
            type,
        )

        this.props.updateState("fields", updatedFields)
    }

    handleTextAreaChange = value => {
        const updatedTextAreaContent = value

        this.props.updateState("textAreaContent", updatedTextAreaContent)
    }

    renderTextAreaForInvites = () => {
        const { fields, textAreaContent, handleTextAreaChange } = this.props
        const allFieldsValid = validateFields(fields)
        const errorText = stringifyInvalidEmails(fields)
        const hasErrors = errorText.length > 0
        return (
            <div className="row">
                <div className="col-md-12 form-group">
                    {hasErrors && (
                        <p className="error-text">
                            {followingAreInvalid}
                            {errorText}
                        </p>
                    )}
                    <textarea
                        ref={this.setTextInputRef}
                        value={textAreaContent}
                        placeholder={textAreaPlaceholder}
                        className={`${
                            allFieldsValid ? "" : "invalid-email-input"
                        } form-control`}
                        onChange={v => {
                            handleTextAreaChange(v.target.value)
                        }}
                    />
                </div>
            </div>
        )
    }

    renderInviteMemberRows = () => (
        <div className="row">
            {Object.keys(this.props.fields).map((id, i) => {
                const field = this.props.fields[id]
                const { isValid, email } = field
                return (
                    <InviteMemberRow
                        key={id}
                        id={id}
                        showLabel={i === 0}
                        removeInviteMemberRow={this.removeInviteMemberRow}
                        onChangeAction={this.handleTextFieldChange}
                        value={email}
                        isValid={isValid}
                        handleBlur={this.handleBlur}
                        refCallback={this.setTextInputRef}
                    />
                )
            })}
        </div>
    )
    renderTextAreaOrRows = () =>
        this.props.isTextArea
            ? this.renderTextAreaForInvites()
            : this.renderInviteMemberRows()

    render() {
        return (
            <div className="invite-team-wrapper">
                {this.renderTextAreaOrRows()}
                <ToggleAddAnother
                    addRow={this.addInviteMemberRow}
                    toggleIsTextArea={this.toggleIsTextArea}
                    isTextArea={this.props.isTextArea}
                    addOneByOne={inviteYourTeamInviteOneByOne}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/invite_team_members.jsx